import React from 'react';
import './ProductCatagories.css';
import { Link } from "react-router-dom";
import Domestic from './img2.jpg'
const ProductCategories = () => {
  return (
    <div className="mainHome-container1">

        <div className="ALLOYMETALS-herosection" >
            <div className="Non-AlloyMETALS-herosection-pic">
                <div className="ALLOYMETALS-herosection-heading">
                    HOME / Non-Alloy Metal Scrap
                </div>
            
            </div>
            
        </div>
        <div className="Each-Product-container" >
        

            <div className="Each-Product-mid-left-container">
                <div className='Each-Product-tittle'>
                NON ALLOY METALS
                </div>
                <div className='Each-Product-mid-details'>
                Non-alloy metals are pure metals that have not been mixed with other elements to modify their properties. They retain their natural characteristics, such as high conductivity, malleability, and ductility. Common examples include iron, copper, aluminum, gold, and silver. While they are useful in various industries, they may lack strength and corrosion resistance compared to alloys.              
                </div>
            </div>
            <div className="Each-Product-mid-right-container">
                <div className="tranding-pics">
                    <img src={Domestic} alt="" className='tranding-left-pics' />
                </div>

            </div>
        </div>
    <section className="Each-Product-Details-card" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Import Scrap</h2>
      
      <section className="product-categories-list">
      <div className="product-categories-list-header">
        
      </div>

      <div className="product-categories-list-grid">
        {productCategoryDetails.map((productCategory, index) => (
          <div key={index} className="product-categories-list-box">
            <div className="Each-product-benifitt-icon"><img src={productCategory.image} alt={productCategory.image} className='Each-Product-Details-card-img'/></div>
            <h3>{productCategory.title}</h3>
            <p>{productCategory.description}</p>
          </div>
        ))}
      </div>
    </section>
      {/* <button className="view-button">View All Products</button> */}
      {/* <h2 className='Product-category-title'>Browse by Category</h2> */}
    </section>
    
    </div>
  );
};

export default ProductCategories;

const productCategoryDetails = [
    {
      title: "Copper Scrap",
      description: "We offer copper wire scrap, clean copper tubing, and copper-based alloys, widely used in electrical manufacturing and construction projects. Copper is highly recyclable and holds its value in the market",
      image: "/Products/Nona/1.webp"
    },
    {
      title: "Aluminum Scrap",
      description: "Our aluminium scrap comes in various forms, including extrusions, rims, and cans. Aluminium is lightweight, corrosion-resistant, and widely used in automotive, aerospace, and packaging industries.",
      image: "/Products/Nona/2.jpg"
    },
    {
      title: "Lead Scrap",
      description: "We offer lead scrap sourced from batteries, pipes, and other materials. Lead is valuable in certain manufacturing processes and is fully recyclable.",
      image: "/Products/Nona/3.jpg"
    },
    {
      title: "Zinc Scrap",
      description: "Sourced from zinc alloys and products, we provide zinc scrap that is used in a variety of applications, from die-casting to galvanizing processes.",
      image: "/Products/Nona/4.webp"
    },
    
  ];
  